import { SharedConstants } from "../../../shared/constants/shared.constants";
export class OrganisationDetailsConstants {
    // Constants
    static BANKING_DETAILS_HEADER_PLACEHOLDER = "Banking details";
    static STREET_ADDRESS_HEADER_PLACEHOLDER = "Street address";
    static POSTAL_ADDRESS_HEADER_PLACEHOLDER = "Postal address";
    static NAME_TEXT_PLACEHOLDER = "Organisation name";
    static CONTACT_PERSON_TEXT_PLACEHOLDER = "Contact person";
    static CONTACT_NUMBER_TEXT_PLACEHOLDER = "Contact number";
    static VAT_REFERENCE_TEXT_PLACEHOLDER = "Vat reference";
    static ALTERNATIVE_NUMBER_TEXT_PLACEHOLDER = "Alternative number";
    static BANKING_DETAILS_1_TEXT_PLACEHOLDER = "Banking details line 1";
    static BANKING_DETAILS_2_TEXT_PLACEHOLDER = "Banking details line 2";
    static BANKING_DETAILS_3_TEXT_PLACEHOLDER = "Banking details line 3";
    static STREET_ADDRESS_TEXT_PLACEHOLDER = "Street address";
    static POSTAL_ADDRESS_TEXT_PLACEHOLDER = "Post address";
    static SUBURB_TEXT_PLACEHOLDER = "Suburb";
    static CITY_TEXT_PLACEHOLDER = "City";
    static PROVINCE_TEXT_PLACEHOLDER = "Province";
    static CODE_TEXT_PLACEHOLDER = "Code";
    static SAME_AS_ADDRESS = "Same as street address";
    static DEFAULT_EXTENT_TEXT_PLACEHOLDER = "Default Extent (JSON string format)";
    static FILTER_PROPERTY = "name eq 'Province'";
    static ORGANISATION_UPDATED_MSG = "Organisation updated";
    static INVALID_DEFAULT_EXTENT = "Invalid default extent. Please make sure the text is in JSON format.";
    static OBJECT_NAME = "Organisation";
    // FormControl Names
    static ORGANISATION_NAME_FORM_CONTROL = "name";
    static CONTACT_PERSON_FORM_CONTROL = "contactPerson";
    static CONTACT_NUMBER_FORM_CONTROL = "contactNumber";
    static ALTERNATIVE_NUMBER_FORM_CONTROL = "alternativeNumber";
    static VAT_REFERENCE_FORM_CONTROL = "vatReference";
    static BANKING_DETAILS_1_FORM_CONTROL = "bankingDetails1";
    static BANKING_DETAILS_2_FORM_CONTROL = "bankingDetails2";
    static BANKING_DETAILS_3_FORM_CONTROL = "bankingDetails3";
    static ADDRESS_FORM_CONTROL = "streetAddress";
    static SUBURB_FORM_CONTROL = "streetSuburb";
    static CITY_FORM_CONTROL = "streetCity";
    static PROVINCE_FORM_CONTROL = "streetProvince";
    static CODE_FORM_CONTROL = "streetCode";
    static POSTAL_ADDRESS_FORM_CONTROL = "postalAddress";
    static POSTAL_SUBURB_FORM_CONTROL = "postalSuburb";
    static POSTAL_CITY_FORM_CONTROL = "postalCity";
    static POSTAL_PROVINCE_FORM_CONTROL = "postalProvince";
    static POSTAL_CODE_FORM_CONTROL = "postalCode";
    static SAME_AS_STREET_FORM_CONTROL = "sameAsStreetAddress";
    static DEFAULT_EXTENT_FORM_CONTROL = "defaultExtent";
    static ORGANIZATION_LOGO_FORM_CONTROL = "Organisation Logo";
    static MODAL_INFO = {
        SUSPEND_ORGANISATION_TITLE_TEXT: "Suspend organisation",
        SUSPEND_ORGANISATION_CONTENT_TEXT: "Are you sure you want to suspend the organisation?",
        REINSTATE_ORGANISATION_TITLE_TEXT: "Reinstate organisation",
        REINSTATE_ORGANISATION_CONTENT_TEXT: "Are you sure you want to reinstate the organisation?"
    };
}
export const validationMessage = {
    name: "Please enter the organisation's name.",
    contactPerson: "Please enter a contact person.",
    contactNumber: SharedConstants.PHONE_NUMBER_VALIDATION_MESSAGE,
    alternativeNumber: SharedConstants.PHONE_NUMBER_VALIDATION_MESSAGE,
    bankingDetails1: "Please enter banking details line 1.",
    bankingDetails2: "Please enter banking details line 2.",
    bankingDetails3: "Please enter banking details line 3.",
    vatReference: "Please enter a VAT reference.",
    streetAddress: "Please enter residential address.",
    streetSuburb: "Please enter suburb.",
    streetCity: "Please enter city.",
    streetProvince: "Please select a province.",
    streetCountry: "Please select a province.",
    streetCode: "Please enter a valid street code.",
    postalAddress: "Please enter postal address.",
    postalSuburb: "Please enter suburb.",
    postalCity: "Please enter city.",
    postalProvince: "Please select a province.",
    postalCountry: "Please select a country.",
    postalCode: "Please enter a valid postal code.",
    defaultExtent: "Please enter a valid default extent"
};
export var ControlStatus;
(function (ControlStatus) {
    ControlStatus["enable"] = "enable";
    ControlStatus["disable"] = "disable";
})(ControlStatus || (ControlStatus = {}));
export const ValidationMessage = {
    name: {
        required: `Organisation name ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`,
        maxlength: `Organisation name ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "150")}`,
    },
    contactPerson: {
        required: `Contact person ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`,
        maxlength: `Contact person ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "150")}`,
    },
    contactNumber: {
        required: `Contact number ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`,
        invalidPhoneNumber: SharedConstants.PHONE_NUMBER_VALIDATION_MESSAGE
    },
    alternativeNumber: {
        invalidPhoneNumber: SharedConstants.PHONE_NUMBER_VALIDATION_MESSAGE
    },
    bankingDetails1: {
        required: `Banking details line 1 ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`,
        maxlength: `Banking details line 1 ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "100")}`,
    },
    bankingDetails2: {
        required: `Banking details line 2 ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`,
        maxlength: `Banking details line 2 ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "100")}`,
    },
    bankingDetails3: {
        required: `Banking details line 3 ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`,
        maxlength: `Banking details line 3 ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "100")}`,
    },
    vatReference: {
        required: `Vat reference ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`,
        maxlength: `Vat reference ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "50")}`,
    },
    streetAddress: {
        required: `Street address ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`,
        maxlength: `Street address ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "150")}`,
    },
    streetSuburb: {
        required: `Surburb ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`,
        maxlength: `Surburb ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "100")}`,
    },
    streetCity: {
        required: `City ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`,
        maxlength: `City ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "100")}`,
    },
    streetProvince: {
        required: `Province ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`,
    },
    streetCountry: {
        required: `Country ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`,
        maxlength: `Country ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "150")}`,
    },
    streetCode: {
        required: `Code ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`,
        pattern: `Code ${SharedConstants.INVALID_INPUT_CONTROL_VALIDATION}`,
    },
    postalAddress: {
        required: `Postal address ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`,
        maxlength: `Postal address ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "150")}`,
    },
    postalSuburb: {
        required: `Suburb ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`,
        maxlength: `Suburb ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "150")}`,
    },
    postalCity: {
        required: `City ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`,
        maxlength: `City ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "150")}`,
    },
    postalProvince: {
        required: `Province ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`,
    },
    postalCountry: {
        required: `Country ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`,
        maxlength: `Country ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "150")}`,
    },
    postalCode: {
        required: `Code ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`,
        pattern: `Code ${SharedConstants.INVALID_INPUT_CONTROL_VALIDATION}`,
    },
    defaultExtent: {
        required: `Default extent ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`,
    }
};
export const FormError = {
    name: "",
    contactPerson: "",
    contactNumber: "",
    alternativeNumber: "",
    bankingDetails1: "",
    bankingDetails2: "",
    bankingDetails3: "",
    vatReference: "",
    streetAddress: "",
    streetSuburb: "",
    streetCity: "",
    streetProvince: "",
    streetCountry: "",
    streetCode: "",
    postalAddress: "",
    postalSuburb: "",
    postalCity: "",
    postalProvince: "",
    postalCountry: "",
    postalCode: ""
};
